import posthog from 'posthog-js'

const POSTHOG_KEY = 'phc_sVUosjoWvErLwZ6fmTykJAoYAjVdVA6eJXEzKyrMfZhP'
const POSTHOG_HOST = 'https://us.i.posthog.com'

// Routes that must never trigger session replay or capture sensitive surfaces.
// Marketing and public pages remain eligible; B2B portal and authenticated app
// routes are excluded so vault data is never captured by session recording.
const PRIVATE_ROUTE_PREFIXES = [
  '/dashboard',
  '/app',
  '/partners',
  '/admin',
  '/vault',
  '/executors',
  '/estate',
  '/documents',
  '/settings',
  '/onboarding',
  '/auth',
];

function isPrivateRoute() {
  if (typeof window === 'undefined') return false;
  const path = window.location?.pathname || '';
  return PRIVATE_ROUTE_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function initPostHog() {
  if (typeof window === 'undefined') return;
  if (window.__posthog_initialised) return;
  window.__posthog_initialised = true;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: '2026-01-30',
    opt_out_capturing_by_default: true,
    capture_pageview: true,
    capture_pageleave: true,
    session_recording: {
      maskAllInputs: true,
    },
    persistence: 'localStorage+cookie',
    autocapture: true,
    // Disable session replay on authenticated/portal routes - only marketing and
    // public pages are eligible for session recording.
    disable_session_recording: isPrivateRoute(),
    sanitize_properties: (properties) => {
      // Belt-and-braces: mark events from private routes so server-side filters
      // can drop session-replay payloads if they ever leak through.
      if (isPrivateRoute()) {
        return { ...properties, $session_recording_disabled: true };
      }
      return properties;
    },
  });
}

export function posthogOptIn() {
  if (typeof window !== 'undefined' && window.__posthog_initialised) {
    posthog.opt_in_capturing();
  }
}

export function posthogOptOut() {
  if (typeof window !== 'undefined' && window.__posthog_initialised) {
    posthog.opt_out_capturing();
  }
}

export { posthog };
